import React from 'react';
import PropTypes from 'prop-types';
import DetailBackButton from './DetailBackButton';
import { Skeleton } from '../Skeleton';
import './detail.css';

const hasValue = value =>
  value !== null && value !== undefined && value !== '' && value !== '-';

/**
 * Top block of every detail page: back button + what state is it in (badges)
 * share the top row; below it where am I (eyebrow), what is it (title), what
 * can I do (actions) and the handful of facts people look for first (facts
 * strip). Everything else belongs in a
 * DetailCard or a tab below.
 */
const DetailHeader = ({
  onBack,
  backLabel,
  eyebrow,
  title,
  subtitle,
  badges,
  actions,
  facts,
  alert,
  loading,
}) => (
  <header className='dt-header'>
    <div className='dt-header__main'>
      <div className='dt-header__body'>
        {(onBack || (!loading && badges)) && (
          <div className='dt-header__top'>
            {onBack && (
              <DetailBackButton onClick={onBack} label={backLabel || 'Back'} />
            )}
            {!loading && badges}
          </div>
        )}

        {loading ? (
          <div role='status' aria-busy='true'>
            <span className='visually-hidden'>Loading</span>
            <Skeleton width='55%' height={24} />
            <Skeleton className='mt-2' width='35%' height={14} />
          </div>
        ) : (
          <>
            {eyebrow && <div className='dt-header__eyebrow'>{eyebrow}</div>}
            <h1 className='dt-header__title'>{title || '-'}</h1>
            {subtitle && <p className='dt-header__subtitle'>{subtitle}</p>}
          </>
        )}
      </div>

      {!loading && actions && (
        <div className='dt-header__actions'>{actions}</div>
      )}
    </div>

    {!loading && alert && <div className='dt-header__alert'>{alert}</div>}

    {!loading && facts?.length > 0 && (
      <dl className='dt-facts'>
        {facts.map(fact => (
          <div className='dt-fact' key={fact.label}>
            {fact.icon && (
              <span className='dt-fact__icon' aria-hidden='true'>
                <i className={fact.icon} />
              </span>
            )}
            <div style={{ minWidth: 0 }}>
              <dt className='dt-fact__label'>{fact.label}</dt>
              <dd className='dt-fact__value mb-0'>
                {hasValue(fact.value) ? fact.value : '-'}
              </dd>
            </div>
          </div>
        ))}
      </dl>
    )}
  </header>
);

DetailHeader.propTypes = {
  onBack: PropTypes.func,
  backLabel: PropTypes.string,
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  badges: PropTypes.node,
  actions: PropTypes.node,
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.node,
    })
  ),
  alert: PropTypes.node,
  loading: PropTypes.bool,
};

export default DetailHeader;
